import React, { useState } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Button from "@mui/material/Button";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import BasicMenu from "../base/BasicMenu";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";

type Anchor = "top" | "left" | "bottom" | "right";

const linguaButton = [
  { value: "it", label: "Italian" },
  { value: "en", label: "English" },
  { value: "pt-BR", label: "Portuguese (Brazil)" },
];

export default function CustomAppBarLogout({ handleLogout }: any) {
  const { t } = useTranslation();
  const [openDrawer, setOpenDrawer] = useState(false);

  const toggleDrawer =
    (anchor: Anchor, open: boolean) =>
    (event: React.KeyboardEvent | React.MouseEvent) => {
      if (
        event.type === "keydown" &&
        ((event as React.KeyboardEvent).key === "Tab" ||
          (event as React.KeyboardEvent).key === "Shift")
      ) {
        return;
      }

      setOpenDrawer(open);
    };
  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar sx={{ backgroundColor: "#222" }} position="static">
        <Toolbar>
          {/* Logo a sinistra */}
          <img
            src={process.env.PUBLIC_URL + "/assets/logo_securfly.png"}
            height="28px"
            alt="logo"
          />
          {/* Spacer */}
          <Box sx={{ flexGrow: 1 }} />
          {/* Logout a destra */}
          <Typography
            variant="subtitle1"
            component="div"
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              paddingRight: "32px",
            }}
          >
            {" "}
            <BasicMenu label={t("LINGUA")} elements={linguaButton} />
          </Typography>{" "}
          <LogoutRoundedIcon onClick={handleLogout} />
          <Button
            onClick={handleLogout}
            color="inherit"
            sx={{ textTransform: "capitalize", fontSize: "medium" }}
          >
            {t("LOGOUT")}
          </Button>
        </Toolbar>
      </AppBar>
    </Box>
  );
}
